export default __webpack_public_path__ + "static/media/youtube-channel.35bde1bd.jpg";